import {BORDER_RADIUS_OUTER} from "../../../config/themes/theme";

export const STYLES = {
  popoverPaperSlotProps: {
    borderRadius: BORDER_RADIUS_OUTER,
    width: "fit-content",
    height: "fit-content",
    position: "relative",
    overflow: "hidden",
  } as const,
  popoverCloseButton: {
    position: "absolute",
    top: "12px",
    right: "12px",
    color: "primary.contrastText",
    zIndex: 10,
  } as const,
};
